import { useState } from "react";
import { updateViewQuestion } from "../../pages/api/hello";

type Question = {
  id: number;
  question: string;
  answer: string;
};

type Props = {
  questions: Question[];
};

export default function FaqAccordion({
  questions,
}: Props) {
    const [openIndex, setOpenIndex] = useState<number | null>(null);
    const [viewedQuestionIds, setViewedQuestionIds] = useState<Set<number>>(new Set());

    const setOpenQuestionIndex = (index: number | null, id: number) => {
        setOpenIndex(prev => (prev === index ? null : index));

        // CHỈ gọi khi mở lần đầu
        setViewedQuestionIds(prev => {
            if (!prev.has(id)) {
            updateViewQuestion(id);
            const next = new Set(prev);
            next.add(id);
            return next;
            }
            return prev;
        });
    };

    return (
      <>
        {questions.length > 0 && (
          <div className="w-full my-6" style={{ fontFamily: "Arial" }}>
            <div>
              <h3 className="font-bold mb-4">
                Mọi người cũng hỏi :
              </h3>

              {questions.map((item, index) => (
                <div
                  key={item.id}
                  className="border-b border-gray-200 py-4"
                >
                  <div
                    onClick={() =>
                      setOpenQuestionIndex(
                        openIndex === index ? null : index,
                        item.id
                      )
                    }
                    className="flex justify-between items-center cursor-pointer"
                  >
                    <span className="leading-relaxed font-semibold">
                      {item.question}
                    </span>

                    <span
                      className={`
                        relative w-7 h-7
                        rounded-full bg-gray-100 hover:bg-gray-200
                        transition-transform duration-300
                        ${openIndex === index ? "rotate-180" : ""}
                      `}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="
                          absolute top-1/2 left-1/2
                          w-4 h-4
                          -translate-x-1/2 -translate-y-1/2
                          text-gray-600
                        "
                      >
                        <polyline points="6 9 12 15 18 9" />
                      </svg>
                    </span>
                  </div>

                  {openIndex === index && (
                    <div
                      className="mt-3 text-gray-600 text-sm"
                      dangerouslySetInnerHTML={{ __html: item.answer }}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </>
    );  
}